import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-help-topic',
	templateUrl: './help-topic.component.html',
	styleUrls: ['./help-topic.component.scss'],
})
export class HelpTopicComponent implements OnInit {
	constructor(private title: Title, private route: ActivatedRoute, public locale: LocaleService) {}

	topic: string;

	ngOnInit(): void {
		this.route.params.subscribe((params: Params) => {
			this.topic = params['topic'];

			// set page title
			if (this.locale.translations) {
				switch (this.topic) {
					case 'placead':
						this.title.setTitle(this.locale.translations['help']['placead']['n127'] + ' | ' + this.locale.translations['header']['n0']);
						break;

					case 'logup':
						this.title.setTitle(this.locale.translations['help']['logup']['n128'] + ' | ' + this.locale.translations['header']['n0']);
						break;

					case 'language':
						this.title.setTitle(this.locale.translations['help']['language']['n129'] + ' | ' + this.locale.translations['header']['n0']);
						break;

					default:
						this.title.setTitle(this.locale.translations['help']['n126'] + ' | ' + this.locale.translations['header']['n0']);
						break;
				}
			}
		});

		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 100);
	}
}
